/* Sales tour — 9 steps. Day-in-the-life for a sales executive. */
export default {
  role: "SALES",
  steps: [
    {
      id: "sales-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.sales.welcome.title", titleFallback: "Welcome, {name}!",
      bodyKey: "tour.sales.welcome.body", bodyFallback: "Quick tour of your daily flow. 9 steps, 4 minutes.",
      side: "bottom",
    },
    {
      id: "sales-pipeline",
      route: "/sales/pipeline",
      selector: '[data-tour-id="sales-pipeline"]',
      titleKey: "tour.sales.pipeline.title", titleFallback: "Your pipeline",
      bodyKey: "tour.sales.pipeline.body", bodyFallback: "Drag deals between stages. Click any card to open. Your assigned leads only.",
      side: "top",
    },
    {
      id: "sales-new-lead",
      route: "/sales/leads",
      selector: '[data-tour-id="leads-page"]',
      titleKey: "tour.sales.newLead.title", titleFallback: "Create a lead",
      bodyKey: "tour.sales.newLead.body", bodyFallback: "+ New lead saves into your pipeline and triggers a follow-up reminder.",
      side: "top",
      optional: true,
    },
    {
      id: "sales-quote",
      route: "/sales/quotes",
      selector: '[data-tour-id="quotes-page"]',
      titleKey: "tour.sales.quote.title", titleFallback: "Quote builder",
      bodyKey: "tour.sales.quote.body", bodyFallback: "Pick a configurator preset, add discount (within band) and generate a PDF.",
      side: "top",
      optional: true,
    },
    {
      id: "sales-configurator",
      route: "/sales/configurator",
      selector: '[data-tour-id="configurator-page"]',
      titleKey: "tour.sales.config.title", titleFallback: "Quick Configurator",
      bodyKey: "tour.sales.config.body", bodyFallback: "30-second pricing — kWh × duty × site → ready-to-quote.",
      side: "bottom",
    },
    {
      id: "sales-visits",
      route: "/sales/visits",
      selector: '[data-tour-id="visits-page"]',
      titleKey: "tour.sales.visits.title", titleFallback: "Visits + GPS check-in",
      bodyKey: "tour.sales.visits.body", bodyFallback: "Punch in at customer site. Geofence enforced. Photos optional.",
      side: "top",
    },
    {
      id: "sales-ai-fab",
      route: "/sales/pipeline",
      selector: '[data-tour-id="ai-fab"]',
      titleKey: "tour.sales.ai.title", titleFallback: "AI Assistant — your second brain",
      bodyKey: "tour.sales.ai.body", bodyFallback: "Ask for proposal drafts, objection handling, GST queries — all in Hinglish or English.",
      side: "left",
    },
    {
      id: "sales-gst-fab",
      route: "/sales/pipeline",
      selector: '[data-tour-id="gst-fab"]',
      titleKey: "tour.sales.gst.title", titleFallback: "GST Advisor",
      bodyKey: "tour.sales.gst.body", bodyFallback: "When the customer asks 'kitna GST lagega?' — point them here.",
      side: "left",
      optional: true,
    },
    {
      id: "sales-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.sales.replay.title", titleFallback: "Replay this tour",
      bodyKey: "tour.sales.replay.body", bodyFallback: "Header button. Anytime. No new-joiner gets left behind.",
      side: "bottom",
    },
  ],
};
